// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3Pjwl","avatar":"style_avatar__1uP6w","menuIcon":"style_menuIcon__2-9Fl"};